import React, { Component } from 'react';

export default class NoAuth extends Component{
    render(){
        return(
            <div>
                <h1>You don't have permission to access this page</h1>
                <h3>Please click <a href="mailto:teamsrequests@ey.com?cc=mobileplatformservices@ey.com &subject=Request%20for%20access%20to%20Campaign%20tool">here</a> to request access or additional information</h3>
            </div>
        )
    }
}